import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomerCateringUsersForStoreQueryVariables = Types.Exact<{
  store_text_id: Types.Scalars['ID'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type GetCustomerCateringUsersForStoreQuery = { __typename?: 'Query', getCustomerCateringUsersForStore: { __typename?: 'GetCustomerCateringUsersForStoreResult', total: number, users: Array<{ __typename?: 'CustomerCateringUser', user_uuid: string, user_name: string, user_email?: string | null, container_amounts: Array<{ __typename?: 'ContainerAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, container_type_size_helper?: string | null, amount: number }> }> } };


export const GetCustomerCateringUsersForStoreDocument = gql`
    query GetCustomerCateringUsersForStore($store_text_id: ID!, $skip: Int!, $take: Int!) {
  getCustomerCateringUsersForStore(
    store_text_id: $store_text_id
    skip: $skip
    take: $take
  ) {
    total
    users {
      user_uuid
      user_name
      user_email
      container_amounts {
        container_type_id
        container_type_name
        container_type_image
        container_type_size_helper
        amount
      }
    }
  }
}
    `;

/**
 * __useGetCustomerCateringUsersForStoreQuery__
 *
 * To run a query within a React component, call `useGetCustomerCateringUsersForStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCateringUsersForStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCateringUsersForStoreQuery({
 *   variables: {
 *      store_text_id: // value for 'store_text_id'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetCustomerCateringUsersForStoreQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerCateringUsersForStoreQuery, GetCustomerCateringUsersForStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerCateringUsersForStoreQuery, GetCustomerCateringUsersForStoreQueryVariables>(GetCustomerCateringUsersForStoreDocument, options);
      }
export function useGetCustomerCateringUsersForStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerCateringUsersForStoreQuery, GetCustomerCateringUsersForStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerCateringUsersForStoreQuery, GetCustomerCateringUsersForStoreQueryVariables>(GetCustomerCateringUsersForStoreDocument, options);
        }
export type GetCustomerCateringUsersForStoreQueryHookResult = ReturnType<typeof useGetCustomerCateringUsersForStoreQuery>;
export type GetCustomerCateringUsersForStoreLazyQueryHookResult = ReturnType<typeof useGetCustomerCateringUsersForStoreLazyQuery>;
export type GetCustomerCateringUsersForStoreQueryResult = Apollo.QueryResult<GetCustomerCateringUsersForStoreQuery, GetCustomerCateringUsersForStoreQueryVariables>;